(() => {
  function connectModelSearch(root, options = {}) {
    root.querySelectorAll('[data-nav-model-group]').forEach((group) => {
      const input = group.querySelector('[data-nav-model-search]');
      const items = [...group.querySelectorAll('[data-nav-model-item]')];
      const status = group.querySelector('[data-nav-model-status]');
      const empty = group.querySelector('[data-nav-model-empty]');
      if (!input || !items.length) return;
      const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      const titles = items.map((item) => normalize(item.dataset.modelTitle));
      input.addEventListener('input', () => {
        const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        let matches = 0;
        items.forEach((item, index) => {
          item.hidden = !words.every((word) => titles[index].includes(word));
          if (!item.hidden) matches++;
        });
        empty.hidden = !words.length || matches > 0;
        status.textContent = words.length ? input.dataset.countText.replace('{{ count }}', String(matches)) : '';
      }, options);
    });
  }

  class RivalNavMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      connectModelSearch(this, options);
      this.details = this.querySelector('details');
      this.summary = this.details.querySelector('summary');
      this.buttons = [...this.querySelectorAll('[data-nav-category]')];
      this.panels = [...this.querySelectorAll('[data-nav-panel]')];
      const select = (button) => {
        this.buttons.forEach((item) => {
          const selected = item === button;
          item.setAttribute('aria-expanded', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.navPanel !== button.dataset.navCategory; });
        this.sizeVehiclePanel();
      };
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button), options);
        button.addEventListener('keydown', (event) => {
          const visible = this.buttons.filter(item => !item.hidden);
          const position = visible.indexOf(button);
          let next;
          if (event.key === 'ArrowDown') next = (position + 1) % visible.length;
          if (event.key === 'ArrowUp') next = (position - 1 + visible.length) % visible.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = visible.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(visible[next]);
          visible[next].focus();
        }, options);
      });
      if (this.buttons.length) select(this.buttons[0]);
      this.addEventListener('rival:directory-filter', () => {
        const visible = this.buttons.filter(button => !button.hidden);
        if (!visible.length) { this.panels.forEach(panel => { panel.hidden = true; }); return; }
        const selected = this.buttons.find(button => button.getAttribute('aria-expanded') === 'true');
        if (!selected || selected.hidden || this.panels.every(panel => panel.hidden)) select(visible[0]);
      }, options);
      this.classList.add('rival-nav--ready');
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.summary.addEventListener('click', (event) => {
        if (event.detail > 0 && this.openedByHover && this.details.open) event.preventDefault();
        this.openedByHover = false;
      }, options);
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) this.sizeVehiclePanel();
        if (this.details.open) document.querySelectorAll('rival-nav-menu').forEach((menu) => { if (menu !== this) menu.close(); });
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || this.dataset.trigger !== 'hover') return;
        clearTimeout(this.closeTimer);
        this.openedByHover = !this.details.open;
        this.details.open = true;
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || this.dataset.trigger !== 'hover') return;
        this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 160);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
          this.summary.focus();
        }
      }, options);
      this.addEventListener('focusout', (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(); }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      window.addEventListener('resize', () => { if (window.innerWidth < 1024) this.close(); else this.sizeVehiclePanel(); }, options);
    }
    sizeVehiclePanel() {
      if (!this.details?.open || !this.details.classList.contains('rival-nav__details--vehicle')) return;
      cancelAnimationFrame(this.sizeFrame);
      this.sizeFrame = requestAnimationFrame(() => {
        const dropdown = this.details.querySelector('.rival-nav__panel');
        const boundary = dropdown.offsetParent;
        if (boundary) {
          const bounds = boundary.getBoundingClientRect();
          const trigger = this.summary.getBoundingClientRect();
          const rtl = getComputedStyle(boundary).direction === 'rtl';
          const start = rtl ? bounds.right - trigger.right : trigger.left - bounds.left;
          this.style.setProperty('--rival-vehicle-menu-start', `${Math.max(0, start)}px`);
        }
        const panel = this.panels.find((item) => !item.hidden);
        if (!panel) return;
        const container = panel.parentElement;
        const style = getComputedStyle(container);
        const height = panel.scrollHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        this.style.setProperty('--rival-vehicle-menu-height', `${Math.min(460, Math.max(280, height))}px`);
      });
    }
    close() { clearTimeout(this.closeTimer); this.openedByHover = false; if (this.details) this.details.open = false; }
    disconnectedCallback() { clearTimeout(this.closeTimer); cancelAnimationFrame(this.sizeFrame); this.controller?.abort(); }
  }
  if (!customElements.get('rival-nav-menu')) customElements.define('rival-nav-menu', RivalNavMenu);

  let finderObserver;
  function connectVehicle() {
    finderObserver?.disconnect();
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"]:is([data-initialized="true"],[data-initialized="ready"])');
    if (!root) return;
    const labels = document.querySelector('.rival-nav');
    document.body.classList.add('rival-garage-refined');
    const sync = () => {
      const active = root.querySelector('[data-rival-active]');
      const selected = active && !active.hidden;
      const label = root.querySelector('[data-rival-active-label]')?.textContent.trim();
      const selection = window.RivalStorefrontFitment?.storedSelection?.();
      const registration = selected ? String(selection?.presentation?.registration || '').trim().toUpperCase().replace(/^([A-Z]{2}\d{2})([A-Z]{3})$/, '$1 $2') : '';
      const manual = !!selected && !registration;
      const vehicleImage = selected ? root.querySelector('.rival-garage__vehicle[data-selected="true"] .rival-vehicle-thumbnail')?.getAttribute('src') : '';
      document.querySelectorAll('[data-nav-vehicle-state]').forEach((card) => {
        card.dataset.navVehicleState = selected ? (manual ? 'manual' : 'registered') : 'empty';
        card.dataset.hasImage = String(!!vehicleImage);
      });
      document.querySelectorAll('[data-nav-vehicle-manual]').forEach((node) => { node.hidden = !manual; });
      document.querySelectorAll('[data-nav-vehicle-empty]').forEach((node) => { node.hidden = !!selected; });
      document.querySelectorAll('[data-nav-vehicle-image]').forEach((node) => {
        node.hidden = !vehicleImage;
        if (vehicleImage && node.getAttribute('src') !== vehicleImage) node.setAttribute('src', vehicleImage);
        if (!vehicleImage) node.removeAttribute('src');
      });
      document.querySelectorAll('[data-nav-vehicle-registration]').forEach((node) => {
        node.hidden = !registration;
        if (node.textContent !== registration) node.textContent = registration;
      });
      document.querySelectorAll('[data-nav-vehicle-browse]').forEach((node) => {
        const destination = selected ? root.querySelector('[data-rival-shop-parts][data-rival-action-ready="true"][href]')?.getAttribute('href') : '';
        const collection = /^\/collections\/[a-z0-9][a-z0-9-]*\/?$/.test(destination || '') ? destination : '';
        node.hidden = !collection;
        if (collection && node.getAttribute('href') !== collection) node.setAttribute('href', collection);
        if (!collection) node.removeAttribute('href');
      });
      document.querySelectorAll('[data-nav-vehicle-label]').forEach((node) => {
        const value = selected && label ? label : node.dataset.emptyLabel;
        if (node.textContent !== value) node.textContent = value;
      });
      document.querySelectorAll('[data-nav-vehicle-action][data-choose-label]').forEach((node) => {
        const value = manual && node.dataset.manualLabel ? node.dataset.manualLabel : selected ? node.dataset.changeLabel : node.dataset.chooseLabel;
        if (node.textContent !== value) node.textContent = value;
      });
      root.querySelectorAll('.rival-garage__vehicle').forEach((vehicle) => {
        const use = vehicle.querySelector('[data-rival-garage-use]');
        const current = vehicle.querySelector('[data-rival-garage-current]');
        if (use && labels?.dataset.garageUseLabel && use.textContent !== labels.dataset.garageUseLabel) use.textContent = labels.dataset.garageUseLabel;
        if (use) {
          const plate = vehicle.querySelector('[data-rival-plate]:not([hidden])')?.textContent.trim();
          const name = vehicle.querySelector('[data-rival-garage-label]')?.textContent.trim();
          const accessibleLabel = [use.textContent.trim(), plate, name].filter(Boolean).join(', ');
          if (use.getAttribute('aria-label') !== accessibleLabel) use.setAttribute('aria-label', accessibleLabel);
        }
        if (current && vehicle.dataset.selected === 'true' && labels?.dataset.garageSelectedLabel && current.textContent !== labels.dataset.garageSelectedLabel) current.textContent = labels.dataset.garageSelectedLabel;
      });
    };
    finderObserver = new MutationObserver(sync);
    finderObserver.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'data-initialized', 'data-selected', 'src', 'href', 'data-rival-action-ready'] });
    sync();
  }

  function connectDrawer() {
    const drawer = document.querySelector('#MenuDrawer.rival-mobile');
    if (!drawer || drawer.dataset.rivalNavReady) return;
    drawer.dataset.rivalNavReady = 'true';
    const closeButton = drawer.querySelector('.rival-mobile__close');
    const headerTitle = drawer.querySelector('#RivalMenuTitle');
    const menuTitle = headerTitle.textContent;
    const headerBack = document.createElement('button');
    headerBack.type = 'button';
    headerBack.className = 'rival-mobile__header-back';
    headerBack.hidden = true;
    headerBack.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m14 6-6 6 6 6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
    headerTitle.after(headerBack);
    drawer.classList.add('rival-mobile--header-back');
    drawer.querySelector('[data-nav-vehicle-image]')?.addEventListener('error', (event) => {
      event.currentTarget.hidden = true;
      event.currentTarget.closest('[data-nav-vehicle-state]').dataset.hasImage = 'false';
    });
    drawer.querySelector('[data-nav-search-action]')?.addEventListener('click', openDrawerSearch);
    const menus = drawer.querySelector('.menu-drawer__menus');
    const branches = [...menus.querySelectorAll('details[is="menu-drawer-details"]')];
    function focusPanel(branch, moveFocus = true) {
      const panel = branch?.querySelector('.menu-drawer__submenu');
      const title = panel?.querySelector(':scope > .rival-mobile__section-title h3')?.textContent.trim() || menuTitle;
      const back = panel?.querySelector(':scope > .rival-mobile__back');
      headerTitle.textContent = title;
      headerTitle.hidden = false;
      drawer.classList.toggle('rival-mobile--submenu', !!branch);
      headerBack.hidden = !branch;
      headerBack.querySelector('span').textContent = 'Back';
      headerBack.setAttribute('aria-label', back ? back.textContent.trim() : 'Back to menu');
      const focus = branch ? headerBack : closeButton;
      [...menus.children].forEach((child) => { if (!child.classList.contains('rival-mobile__list')) child.inert = !!branch; });
      menus.querySelectorAll('.rival-mobile__list > li').forEach((li) => {
        li.inert = !!branch && !li.contains(branch);
        const summary = li.querySelector('details > summary');
        if (summary) summary.inert = !!branch;
      });
      branches.forEach((item) => {
        const section = item.querySelector(':scope > .menu-drawer__submenu');
        const active = !branch || item === branch;
        [...section.children].forEach((child) => {
          if (!child.classList.contains('rival-mobile__children')) child.inert = !active;
        });
        section.querySelectorAll(':scope > .rival-mobile__children > li').forEach((li) => {
          li.inert = !active && !li.contains(branch);
          const summary = li.querySelector(':scope > details > summary');
          if (summary) summary.inert = !active;
        });
      });
      if (moveFocus && drawer.open) focus.focus();
    }
    const activeBranch = () => branches.findLast((branch) => branch.open && !branch.querySelector('details[is="menu-drawer-details"][open]'));
    headerBack.addEventListener('click', () => {
      // Retain the theme's existing branch close and focus restoration handlers.
      activeBranch()?.querySelector(':scope > .menu-drawer__submenu > .rival-mobile__back')?.click();
    });
    branches.forEach((branch) => {
      branch.addEventListener('toggle', () => {
        const active = activeBranch();
        if (branch.open) menus.scrollTop = 0;
        focusPanel(active, branch.open && branch === active);
      });
      branch.querySelector('.rival-mobile__back').addEventListener('click', () => {
        focusPanel(branch.parentElement.closest('details[is="menu-drawer-details"]'), false);
        branch.querySelector('summary').focus();
      });
    });
    drawer.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && drawer.open) {
        const branch = activeBranch();
        if (branch) {
          event.preventDefault();
          event.stopPropagation();
          branch.querySelector('.rival-mobile__back').click();
          return;
        }
      }
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !drawer.open) return;
      const items = [...drawer.querySelectorAll('summary,a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]')].filter((node) => !node.closest('[inert],[hidden]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
      if (!items.length) return;
      event.preventDefault();
      event.stopPropagation();
      const index = items.indexOf(document.activeElement);
      items[(index + (event.shiftKey ? -1 : 1) + items.length) % items.length].focus();
    });
    drawer.addEventListener('drawer:handleAfterHide', () => {
      focusPanel(null);
    });
    focusPanel(activeBranch(), false);
    window.matchMedia('(min-width:1024px)').addEventListener('change', (event) => { if (event.matches && drawer.isConnected && drawer.open) drawer.hide(); });
  }

  function openDrawerSearch(event) {
    if (event.button > 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const search = document.querySelector('header predictive-search[data-search-enabled="true"]');
    const input = search?.querySelector('input[type="search"]');
    if (!input || typeof search.open !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    const drawer = event.currentTarget.closest('menu-drawer');
    if (drawer?.open) {
      drawer.activeElement = input;
      drawer.hide();
      window.FoxTheme?.a11y?.removeTrapFocus?.();
    }
    input.focus({ preventScroll: true });
    search.open();
  }

  document.addEventListener('click', async (event) => {
    const action = event.target.closest('[data-nav-vehicle-action]');
    if (!action) return;
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"]:is([data-initialized="true"],[data-initialized="ready"])');
    if (!root) return;
    const active = root.querySelector('[data-rival-active]');
    const selected = active && !active.hidden;
    const trigger = root.querySelector(selected ? '[data-rival-change]' : '[data-rival-open-finder]');
    if (!trigger || trigger.disabled) return;
    event.preventDefault();
    document.querySelectorAll('rival-nav-menu').forEach((menu) => menu.close());
    const drawer = action.closest('menu-drawer');
    if (drawer?.open) {
      await drawer.hide();
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
    const focusTarget = drawer ? document.querySelector('.menu-drawer-button') : action.closest('rival-nav-menu')?.querySelector('summary');
    focusTarget?.focus({ preventScroll: true });
    trigger.click();
  });
  function mount() { connectDrawer(); connectVehicle(); }
  mount();
  ['DOMContentLoaded', 'rival:finder-ready', 'shopify:section:load'].forEach((event) => document.addEventListener(event, mount));
})();
